import React, { Component } from "react";
import {
  Button,
  Space,
  Col,
  message,
  Form,
  Input,
  Row,
  Select,
  Upload,
  Modal,
  Tooltip,
  Spin,
  Checkbox,
} from "antd";
import "./Form.css";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import UsersStore from "../store/UsersStore";
import CreditStore from "../store/CreditStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import DepartmentStore from "../store/DepartmentStore";
import { Link } from "react-router-dom";
import config from "../config";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import RoleStore from "../store/RoleStore";
import conf from "../config";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";

const layout = {
  labelCol: { span: 23 },
  wrapperCol: { span: 30 },
};
const { Option } = Select;
class CreditAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      companyId: "",
      loadList: 0,
      offset: "",
      limit: "",
      searchField: "",
      getRolesList: [],
      departmentId: "",
      userId: -1,
      fileList: [],
      showDeptForm: false,
      loading: false,
      isadmin: 0,
      userType: 1,
      loadingSpin: false,
      disabledField: false,
      isInvoiceGenerated: false,

      submitAction: null
    };
    this.userStore = new UsersStore();
    this.roleStore = new RoleStore();
    this.creditStore = new CreditStore();
    this.departmentStore = new DepartmentStore(this);
    // this.selectDepartment = this.selectDepartment.bind(this);
    this.cookies = new Cookies();
    this.handleChange = this.handleChange.bind(this);
    //  console.log(this.props.getUserData().roleId)
    console.log(JSON.parse(base64_decode(this.cookies.get("data"))).roleId);
  }



  onInvoiceSubmit = async (fieldsValue) => {
  //  console.log('innnnnnnnnnn')
   // console.log(fieldsValue)
   // console.log(this.state.submitAction)
   
   // {"creditType":"New","mail":"testinv@gmail.com","noofcredit":"500","currency":"\u20b9","amount":"300","companyname":"testinv","companyId":"548","id":"225","invoiceNo":"0","cdate":"2025-05-23"}
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      createdUserId: this.props.getUserData().userId,
      createdCompanyId: this.props.getUserData().userCompanyId,
      companyId: this.state.companyId,
      companyname: this.state.companyname,
      id: this.state.recordId ? this.state.recordId : 0,
      submitAction: this.state.submitAction
    };
    //console.log(data);
    const resp = await this.creditStore.saveInvoice(data);
    if(resp.data?.fileName){
        this.setState({ isInvoiceGenerated: true,invoice:resp.data.fileName });
    }
    
   // await this.setState()
   
    await this.props.response(resp);
    if(this.state.submitAction==='sendinvoice'){
        this.closeModal2();

    }
    this.setState({ loading: false });
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setUserAddStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      // await this.setState({userId:this.props.getUserData().userId})
      await this.setState({ isadmin: this.props.getUserData().isadmin });
    }
    await this.departmentStore.getUserDepartmentData();
    await this.setState({ loadList: 1 });
    console.log(this.props.userId);
    const recordId = this.props.recordId;
   

    if (recordId) {
      this.filldata(recordId);
      this.setState({ recordId: recordId });
    }
  }
  async filldata(recordId) {
    await this.setState({ loadingSpin: true });
    const recordData = await this.creditStore.editData(recordId);

    if(recordData.invoice){
       await this.setState({ isInvoiceGenerated: true,invoice:recordData.invoice });
    }

      console.log(recordData)
    this.formRef.current.setFieldsValue({
      // photo: getUserData.photo,
      creditType: recordData.creditType,
      mail : recordData.contact1Email,
      noofcredit : recordData.totalcreditAvailable,
      currency: recordData.currency,
      amount: recordData.amount
    });


    
    await this.setState({ loadingSpin: false,companyId: recordData.companyId,companyname: recordData.companyName });
  }

  async handleChange(comp) {
     await this.setState({ companyId: comp.value });
   
  }




  
  closeModal2 = () => {
    this.props.closeModal2();
  };
  handleButtonClick = (action) => {
    this.setState({ submitAction: action });
  };
  render() {
    return (
      <div style={{ padding: 0 }}>
        <div style={{ paddingBottom: "10px" }}>
          {/* change style */}
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              {...layout}
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onInvoiceSubmit}
              className="formClass" //change
            >
              <Row className="overflowFormInputs">
                {/* css class */}
                <Col span={12} className="formColumnClass">
                  {/* css class */}

                 
                  <Form.Item
                    name="creditType"
                    label={this.context.translate("_CREDIT_TYPE_")}
                  
                  >
                    <Input />
                  </Form.Item>

                   <Form.Item
                    name="mail"
                    label={this.context.translate("_FLEET_LOGIN_EMAILLBL_")}
               
                  >
                    <Input />
                  </Form.Item>

                   

                   <Form.Item
                    name="amount"
                    label={this.context.translate("_PRICE_")}
                  
                  >
                    <Input />
                  </Form.Item>


                
                </Col>

                <Col span={12} className="formColumnClass">

                <Form.Item
                    name="noofcredit"
                    label={this.context.translate("_CREDIT_AVAILABLE_")}
                  
                  >
                    <Input />
                  </Form.Item>

                 <Form.Item
                      name="currency"
                      label={this.context.translate(
                        "_CURRENCY_"
                      )}
                      rules={[{ required: true,message: this.context.translate("_PLEASE_SELECT_CURRENCY_") }]}
                    >
                      <Select
                        placeholder={this.context.translate(
                                  "_SELECT_CURRENCY_"
                                )}
                      >
                       
                        <Select.Option value="Rupees">
                          {this.context.translate("\u20B9")}
                        </Select.Option>
                        <Select.Option value="Doller">
                          {this.context.translate("$")}
                        </Select.Option>
                           <Select.Option value="Dirham">
                          {this.context.translate("د.إ")}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                
                  
                 

                  

                  
                </Col>
              </Row>

              
           
            <div className="formBtnGroup">
                          {/* css class */}
                         <Space>
                          <Button
                            className=""
                            onClick={(e) => {
                                  this.closeModal2();
                                  // this.formRef.current?.resetFields();
                                }}
                          >
                            {/* css class */}
                            {/* Cancel */}
                            {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
                          </Button>
                         {this.props.editType=='generate' && <Button
                            type="primary"
                            className=""
                            htmlType="submit"
                            loading={this.state.loading}
                            disabled={this.state.isInvoiceGenerated}
                            onClick={() => this.handleButtonClick("generate")}
                          >
                            {/* css class */}
                            {/* Save */}
                            {this.context.translate("_GENERATE_")}
                          </Button> }

                           {this.props.editType=='edit' && <Button
                            type="primary"
                            className=""
                            htmlType="submit"
                            loading={this.state.loading}
                         //   disabled={this.state.isInvoiceGenerated}
                            onClick={() => this.handleButtonClick("generate")}
                          >
                            {/* css class */}
                            {/* Save */}
                            {this.context.translate("_UPDATE_")}
                          </Button> }  


                          <Button
                            type="primary"
                            className=""
                            htmlType="submit"
                            loading={this.state.loading}
                            disabled={!this.state.isInvoiceGenerated}
                            onClick={(e) => {
                                  window.open(config.fleetURL+'/images/reports/'+this.state.invoice, '_blank');
                            }}
                          >
                            {/* css class */}
                            {/* Save */}
                            {this.context.translate("_PREVIEW_")}
                          </Button>
                          <Button
                            type="primary"
                            className=""
                            htmlType="submit"
                            loading={this.state.loading}
                            onClick={() => this.handleButtonClick("sendinvoice")}
                          >
                            {/* css class */}
                            {/* Save */}
                            {this.context.translate("_SEND_INVOICE_")}
                          </Button>

                          </Space>
                        </div>
          </Form>
          </Spin>
        </div>
       </div>
    );
  }
}
CreditAdd.contextType = StoreContext;
export default observer(withRouter(CreditAdd));
